import React, { useEffect, useState } from "react";
import Title from "../../new-components/title/Title";
import { GetCompanies, getCompaniesRequest } from "../../API/activities";
import { Link, useParams, useNavigate } from "react-router-dom";
import Overllay from "../../assets/new_imgs/Rectangle 1072.png";
import CustomBusinessServiceLoader from "../../Components/Loaders/CustomBusinessServiceLoader";
import HeaderInner from "../../Components/HeaderInner";
import { Zoom } from "react-reveal";
import { useBusinessNameContext } from "../../context/BusinessName";

const ActivitiesCompanies = () => {
  const lang = sessionStorage.getItem("lang");
  const params = useParams();
  const { businessName } = useBusinessNameContext();
  const navigate = useNavigate();
  const new_design = localStorage.getItem("new_design");
  const theme = new_design === "true";
  const { data, isError, isLoading } = GetCompanies(params.room_uuid, lang);

  useEffect(() => {
    if (
      !isLoading &&
      !isError &&
      data?.data?.activities_companies?.length === 1
    ) {
      const singleCompany = data.data.activities_companies[0];
      navigate(
        `/${params.room_uuid}/activities/categories/${singleCompany.uuid}`,
        { replace: true }
      );
    }
  }, [isLoading, isError, data, navigate, params.room_uuid]);

  if (isError) return <></>;

  return (
    <div
      className={`
  ${
    theme && businessName === "Beno Jumeirah Sport Activity"
      ? "food pb-1 activities-custom-styles"
      : ""
  }
  ${theme ? "food pb-1" : ""}
 ${lang === "AR" && "arabic"}`}
    >
      {/* <Title title={data?.data?.header_title || ""} /> */}
      {theme ? (
        <Title title={data?.data?.header_title || ""} />
      ) : (
        <HeaderInner headerName={data?.data?.header_title || ""} />
      )}
      {isLoading ? (
        <CustomBusinessServiceLoader
          businessName={"Companies"}
          loader={"spa"}
        />
      ) : (
        <main className="box_food image_services home-main bg-white back-white ">
          {data.data.activities_companies.map((company) => (
            <Zoom>
              <Link
                key={company.uuid}
                to={`/${params.room_uuid}/activities/categories/${company.uuid}`}
                style={{
                  marginTop: !theme && "10px",
                  marginBottom: !theme && "10px",
                }}
              >
                <img src={company.logo} alt="" className="service_img" />
                {theme && <img src={Overllay} alt="" className="overlay" />}
                <h6
                  className="sub_title"
                  style={{
                    marginTop: !theme && "5px",
                  }}
                >
                  {company.name}
                </h6>
              </Link>
            </Zoom>
          ))}
        </main>
      )}
    </div>
  );
};

export default ActivitiesCompanies;
